// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2VcIA","large":"styles_large__1xdvg"};